/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListForumCategories200ResponseDataInner } from './ListForumCategories200ResponseDataInner';
import {
    ListForumCategories200ResponseDataInnerFromJSON,
    ListForumCategories200ResponseDataInnerFromJSONTyped,
    ListForumCategories200ResponseDataInnerToJSON,
    ListForumCategories200ResponseDataInnerToJSONTyped,
} from './ListForumCategories200ResponseDataInner';

/**
 * 
 * @export
 * @interface ShowCategory200Response
 */
export interface ShowCategory200Response {
    /**
     * 
     * @type {ListForumCategories200ResponseDataInner}
     * @memberof ShowCategory200Response
     */
    data?: ListForumCategories200ResponseDataInner;
}

/**
 * Check if a given object implements the ShowCategory200Response interface.
 */
export function instanceOfShowCategory200Response(value: object): value is ShowCategory200Response {
    return true;
}

export function ShowCategory200ResponseFromJSON(json: any): ShowCategory200Response {
    return ShowCategory200ResponseFromJSONTyped(json, false);
}

export function ShowCategory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowCategory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ListForumCategories200ResponseDataInnerFromJSON(json['data']),
    };
}

export function ShowCategory200ResponseToJSON(json: any): ShowCategory200Response {
    return ShowCategory200ResponseToJSONTyped(json, false);
}

export function ShowCategory200ResponseToJSONTyped(value?: ShowCategory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ListForumCategories200ResponseDataInnerToJSON(value['data']),
    };
}

